import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { SdmCircularLoader } from 'components';

/* eslint-disable */
export const SdmIconButtonLoader = forwardRef(
  (
    {
      children,
      callback,
      loaderStyle,
      buttonStyle,
      cursorType = 'pointer',
      ...rest
    },
    ref
  ) => {
    useImperativeHandle(ref, () => ({
      click() {
        handleCallback();
      },
    }));

    const [isLoading, setIsLoading] = useState(false);
    const handleCallback = async () => {
      if (callback && !isLoading) {
        setIsLoading(true);
        await callback();
        setTimeout(() => {
          setIsLoading(false);
        }, 300);
      }
    };
    return isLoading ? (
      <SdmCircularLoader
        style={{
          margin: -4,
          ...loaderStyle,
        }}
      />
    ) : (
      <div
        onClick={handleCallback}
        style={{
          padding: 4,
          cursor: cursorType,
          ...buttonStyle,
        }}
        {...rest}
      >
        {children}
      </div>
    );
  }
);
/* eslint-enable */
